export enum EAccountStatuses {
  Initial = 'initial',
  Pending = 'pending',
  Approved = 'approved',
  Declined = 'declined',
  FinalDeclined = 'final_declined'
}
